import axios from 'axios'
import {ID} from '../../../../../../_metronic/helpers'
import {ContactUs} from './_models'

const API_URL = process.env.REACT_APP_API_URL + '/contact-us'

const createContactUs = (contactUs: ContactUs): Promise<ContactUs | undefined> => {
  return axios.post(API_URL, contactUs)
}

const updateContactUs = (contactUs: ContactUs): Promise<ContactUs | undefined> => {
  return axios.patch(`${API_URL}/${contactUs.id}`, contactUs)
}

const deleteContactUs = (contactUsId: ID): Promise<void> => {
  return axios.delete(`${API_URL}/${contactUsId}`)
}

export {deleteContactUs, createContactUs, updateContactUs}
